// extracted by mini-css-extract-plugin
export default {"search":"SearchBar_search__k2XBh","searchButton":"SearchBar_searchButton__-Q8qV","searchIcon":"SearchBar_searchIcon__PIUmS"};